import { render, staticRenderFns } from "./carts.vue?vue&type=template&id=37c0edc4&scoped=true"
import script from "./carts.vue?vue&type=script&lang=js"
export * from "./carts.vue?vue&type=script&lang=js"
import style0 from "./carts.vue?vue&type=style&index=0&id=37c0edc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0edc4",
  null
  
)

export default component.exports